import React from 'react';
import { ESRD, IPPS, LTCH, OPPS, PFS, PSYCH, REHAB, HH, SNF, FQHC } from '../../../Constants/modelTypes';
import { API_DATE_STRING_FORMAT, DATE_STRING_FORMAT } from '../../../Constants/stringFormats';
import { formatDateString, formatStringAsCurrency, formatStringWithPrecision } from '../../../Utils/stringUtils';
import { ResultValue } from '../../Simple';

export default function ClaimDetails(props) {

    if (props.model === IPPS) {
        return (<>
            <h4>Claim Details</h4>
            <ResultValue label="DRG" value={props.result.pricingDRG} />
            <ResultValue label="Admit Date" value={formatDateString(props.result.fromDate, API_DATE_STRING_FORMAT, DATE_STRING_FORMAT)} />
            <ResultValue label="Discharge Date" value={formatDateString(props.result.toDate, API_DATE_STRING_FORMAT, DATE_STRING_FORMAT)} />
            <ResultValue label="Length of Stay" value={props.result.los} />
            <ResultValue label="Billed: Net of Organ Acquisition" value={formatStringAsCurrency(props.result.totalBilled)} />
            <ResultValue label="Billed: Organ Acquisition" value={formatStringAsCurrency(props.totalBilledOrgAcquistion)} />
        </>);
    }

    if (props.model === PSYCH) {
        return (<>
            <h4>Claim Details</h4>
            <ResultValue label="Date of Birth" value={props.dateOfBirth} />
            <ResultValue label="DRG" value={props.result.pricingDRG} />
            <ResultValue label="From Date" value={formatDateString(props.result.fromDate, API_DATE_STRING_FORMAT, DATE_STRING_FORMAT)} />
            <ResultValue label="To Date" value={formatDateString(props.result.toDate, API_DATE_STRING_FORMAT, DATE_STRING_FORMAT)} />
            <ResultValue label="Length of Stay" value={props.result.los} />
            <ResultValue label="Prior Days" value={props.result.previousDays} />
            <ResultValue label="Non-Covered Days" value={props.result.nonCoveredDays} />
            <ResultValue label="Billed" value={formatStringAsCurrency(props.result.totalBilled)} />
        </>);
    }

    if (props.model === REHAB) {
        return (
            <>
                <h4>Claim Details</h4>
                <ResultValue label="CMG on Claim" value={props.result.cmgOnClaim} />
                <ResultValue label="Priced CMG" value={props.result.pricedCMG} />
                <ResultValue label="Admit Date" value={formatDateString(props.result.admitDate, API_DATE_STRING_FORMAT, DATE_STRING_FORMAT)} />
                <ResultValue label="Discharge Date" value={formatDateString(props.result.dischargeDate, API_DATE_STRING_FORMAT, DATE_STRING_FORMAT)} />
                <ResultValue label="Length of Stay (LOS)" value={props.result.coveredDays} />
                <ResultValue label="Covered Days" value={props.result.coveredDays} />
                <ResultValue label="Non-Covered Days" value={props.result.nonCoveredDays} />
                <ResultValue label="Billed" value={formatStringAsCurrency(props.result.totalBilled)} />
            </>
        );
    }

    if (props.model === LTCH) {
        return (<>
            <h4>Claim Details</h4>
            <ResultValue label="DRG" value={props.result.pricingDRG} />
            <ResultValue label="Admit Date" value={formatDateString(props.result.fromDate, API_DATE_STRING_FORMAT, DATE_STRING_FORMAT)} />
            <ResultValue label="Discharge Date" value={formatDateString(props.result.toDate, API_DATE_STRING_FORMAT, DATE_STRING_FORMAT)} />
            <ResultValue label="Length of Stay (LOS)" value={props.result.coveredDays} />
            <ResultValue label="Covered Days" value={props.result.coveredDays} />
            <ResultValue label="Non-Covered Days" value={props.result.nonCoveredDays} />
            <ResultValue label="Billed" value={formatStringAsCurrency(props.result.totalBilled)} />
        </>);
    }

    if (props.model === OPPS) {
        return (<>
            <h4>Claim Details</h4>
            <ResultValue label="From Date" value={formatDateString(props.result.fromServiceDate, API_DATE_STRING_FORMAT, DATE_STRING_FORMAT)} />
            <ResultValue label="To Date" value={formatDateString(props.result.toServiceDate, API_DATE_STRING_FORMAT, DATE_STRING_FORMAT)} />
            <ResultValue label="Total Billed" value={formatStringAsCurrency(props.result.totalBilled)} />
            <ResultValue label="MSA" value={props.result.msa} />
            <ResultValue label="MSA Description" value={props.result.msaDescription} />
            <ResultValue label="POS" value={props.result.pos} />
            <ResultValue label="Bill Type" value={props.result.billType} />
        </>);
    }


    if (props.model === PFS) {
        return (<>
            <h4>Claim Details</h4>
            <ResultValue label="From Date" value={formatDateString(props.result.fromServiceDate, API_DATE_STRING_FORMAT, DATE_STRING_FORMAT)} />
            <ResultValue label="To Date" value={formatDateString(props.result.toServiceDate, API_DATE_STRING_FORMAT, DATE_STRING_FORMAT)} />
            <ResultValue label="Total Billed" value={formatStringAsCurrency(props.result.totalBilled)} />
            <ResultValue label="MSA" value={props.result.msa} />
            <ResultValue label="MSA Description" value={props.result.msaDescription} />
            <ResultValue label="POS" value={props.result.pos} />
            <ResultValue label="Specialty Code" value={props.result.specialtyCode} />
        </>);
    }

    if (props.model === SNF) {
        return (<>
            <h4>Claim Details</h4>
            <ResultValue label="Zip Code" value={props.result.zipCode} />
            <ResultValue label="CBSA" value={props.result.cbsa} />
            <ResultValue label="From Date" value={formatDateString(props.result.admitDate, 'yyyy-MM-dd', 'MM/dd/yyyy')} />
            <ResultValue label="To Date" value={formatDateString(props.result.dischargeDate, 'yyyy-MM-dd', 'MM/dd/yyyy')} />
            <ResultValue label="Previous Days" value={props.result.previousDays} />
        </>);
    }

    if (props.model === ESRD) {
        return (<>
            <h4>Claim Details</h4>
            <ResultValue label="From Date" value={formatDateString(props.result.fromServiceDate, API_DATE_STRING_FORMAT, DATE_STRING_FORMAT)} />
            <ResultValue label="To Date" value={formatDateString(props.result.toServiceDate, API_DATE_STRING_FORMAT, DATE_STRING_FORMAT)} />
            <ResultValue label="Total Billed" value={formatStringAsCurrency(props.result.totalBilled)} />
            <ResultValue label="Date of Birth" value={props.result.dob} />
            <ResultValue label="Height (cm)" value={props.result.height} />
            <ResultValue label="Weight (kg)" value={props.result.weight} />
            <ResultValue label="MSA" value={props.result.msa} />
            <ResultValue label="MSA Description" value={props.result.msaDescription} />
        </>);
    }

    if (props.model === HH) {
        return (<>
            <h4>Claim Details</h4>
            <ResultValue label="Beneficiary Zip Code" value={props.result.beneficiaryZip} />
            <ResultValue label="CBSA" value={props.result.cbsa} />
            <ResultValue label="Admit Date" value={formatDateString(props.result.admitDate, 'yyyy-MM-dd', 'MM/dd/yyyy')} />
            <ResultValue label="From Date" value={formatDateString(props.result.fromDate, 'yyyy-MM-dd', 'MM/dd/yyyy')} />
            <ResultValue label="To Date" value={formatDateString(props.result.toDate, 'yyyy-MM-dd', 'MM/dd/yyyy')} />
        </>);
    }

    if (props.model === FQHC) {
        return (<>
            <h4>Claim Details</h4>
            <ResultValue label="GAF" value={formatStringWithPrecision(props.result.gaf)} />
            <ResultValue label="From Date" value={formatDateString(props.result.fromDate, 'yyyy-MM-dd', 'MM/dd/yyyy')} />
            <ResultValue label="To Date" value={formatDateString(props.result.toDate, 'yyyy-MM-dd', 'MM/dd/yyyy')} />
        </>);
    }

    console.warn('Model unknown:', props.model);
    return null;
}